import { AlertDialog, Button } from '@fhs/ui';

type CloseConfirmationDialogProps = {
  onDismiss: () => void;
  onConfirm: () => void;
  isOpen: boolean;
};

export const CloseConfirmationModal = ({
  onDismiss,
  onConfirm,
  isOpen,
}: CloseConfirmationDialogProps) => {
  return (
    <AlertDialog
      visible={isOpen}
      onClose={onDismiss}
      headingContent="Gift Card Not Added"
      bodyContent="Are you sure you want to leave before adding the gift card to your account?"
      hideCloseIcon
      actions={
        <>
          <Button size="xl" type="solid" onPress={onConfirm}>
            <Button.Text>Add Gift Card</Button.Text>
          </Button>
          <Button size="xl" type="outline" onPress={onDismiss}>
            <Button.Text>Leave</Button.Text>
          </Button>
        </>
      }
    />
  );
};
